import { Typography } from "@mui/material";
import { useEffect, useState } from "react";
import { HelpCenter } from "@mui/icons-material";
import { useGetEingangsrechnung } from "../../client/hooks";
import { EingangsrechnungInfo } from "../../api";

export default function GutschriftenHinweis({
  rechnungId,
}: {
  rechnungId: string;
}) {
  const getRechnung = useGetEingangsrechnung();
  const [rechnungInfo, setRechnungInfo] = useState<
    EingangsrechnungInfo | undefined
  >(undefined);

  useEffect(() => {
    const fetchRechnung = async () => {
      let rechnung = await getRechnung(rechnungId);
      setRechnungInfo(rechnung);
    };
    fetchRechnung();
  }, [getRechnung, rechnungId]);

  return (
    <>
      {(rechnungInfo?.gutschriftenIds?.length ?? 0) > 0 ? (
        <Typography variant="h5" color={"text.secondary"}>
          <HelpCenter /> Folgende Gutschriften sind auf die Rechnung angewendet
          worden: {rechnungInfo?.gutschriftenRechnungsnummern}
        </Typography>
      ) : (
        <></>
      )}
    </>
  );
}
